// Vendor Libs
import React from 'react';
import PropTypes from 'prop-types';

// Components
import Icon from '../core/icon';
import TooltipTrigger from '../core/tooltip-trigger';

// Styles
import './bingeable-indicator.scss';

function BingeableIndicator({vfb}) {
    const {bingeable, exactEpisodicSequencing} = vfb || {};

    const getTooltipProps = () => ({
        className: 'bingeable-indicator--sequencing-message',
        tooltipRenderer: renderSequencingInfo,
    });

    const renderSequencingInfo = () => {
        const requirement = exactEpisodicSequencing ? (
            <span className="bingeable-indicator--sequencing-message-required">required</span>
        ) : (
            <span>not required</span>
        );

        return (
            <section className="bingeable-indicator--sequencing-message-overlay">
                <div className="bingeable-indicator--sequencing-message-prefix">Exact sequencing {requirement}</div>
            </section>
        );
    };

    return bingeable ? (
        <TooltipTrigger {...getTooltipProps()}>
            <Icon className="bingeable-indicator--couch-icon" fontType="mc" iconName="couch" />
        </TooltipTrigger>
    ) : null;
}

BingeableIndicator.propTypes = {
    vfb: PropTypes.object,
};

export default BingeableIndicator;
